(() => {
  const overlay = document.querySelector('[data-personalization]');
  if (!overlay) return;

  const dialog = overlay.querySelector('[role="dialog"]');
  const form = overlay.querySelector('[data-personalization-form]');
  if (!dialog || !form) return;

  const offers = {
    book: {
      label: 'Livre personnalisé',
      variant: overlay.dataset.bookVariant,
      sku: overlay.dataset.bookSku,
    },
    coffret: {
      label: 'Coffret d’aventure',
      variant: overlay.dataset.boxVariant,
      sku: overlay.dataset.boxSku,
    },
  };

  const summary = overlay.querySelector('.contelune-personalization__summary');
  let currentStep = 1;
  let lastTrigger;

  const getStep = (number) => overlay.querySelector(`[data-personalization-step="${number}"]`);
  const field = (name) => form.elements.namedItem(`properties[_${name}]`) || form.elements.namedItem(`properties[${name}]`);
  const checkoutField = (selector) => form.querySelector(selector);
  const concise = (text, limit = 90) => text.length > limit ? `${text.slice(0, limit - 1).trim()}…` : text;
  const value = (name) => {
    const control = field(name);
    if (!control) return '';
    if (control instanceof RadioNodeList) return control.value.trim();
    return String(control.value || '').trim();
  };

  const updateSummary = () => {
    if (!summary) return;
    const childName = value('contelune_child_name');
    const childAge = value('contelune_child_age');
    const selectedWorld = value('contelune_world');
    const world = selectedWorld === 'CUSTOM' ? value('contelune_custom_world') : selectedWorld === 'SURPRISE' ? 'Une aventure surprise' : selectedWorld;
    const dedicationMode = value('contelune_dedication_mode');
    const dedication = dedicationMode === 'ASSISTED' ? summary.dataset.summaryAssisted : value('contelune_dedication') || summary.dataset.summaryEmpty;
    const interests = value('contelune_interests');
    const tone = value('contelune_tone');
    const occasion = value('contelune_occasion');
    const child = [childName, childAge ? `${childAge} ans` : ''].filter(Boolean).join(', ');
    const story = [tone, interests ? `autour de ${interests}` : ''].filter(Boolean).join(' · ');
    const dedicationStatus = dedicationMode === 'ASSISTED'
      ? 'Nous vous aidons à le rédiger'
      : value('contelune_dedication')
        ? 'Ajouté en première page'
        : 'Aucun petit mot';

    checkoutField('[data-checkout-child]').value = child;
    checkoutField('[data-checkout-world]').value = concise(world || 'À imaginer par Contelune');
    checkoutField('[data-checkout-story]').value = concise(story);
    checkoutField('[data-checkout-occasion]').value = occasion;
    checkoutField('[data-checkout-dedication]').value = dedicationStatus;

    summary.querySelector('[data-summary-offer]').textContent = overlay.querySelector('[data-personalization-offer]').textContent;
    summary.querySelector('[data-summary-child]').textContent = child || '—';
    summary.querySelector('[data-summary-world]').textContent = world || '—';
    summary.querySelector('[data-summary-occasion]').textContent = occasion || '—';
    summary.querySelector('[data-summary-companions]').textContent = value('contelune_companions') || summary.dataset.summaryNone;
    summary.querySelector('[data-summary-dedication]').textContent = dedication;
  };

  const showStep = (number) => {
    currentStep = number;
    overlay.querySelectorAll('[data-personalization-step]').forEach((step) => {
      const active = Number(step.dataset.personalizationStep) === number;
      step.hidden = !active;
      step.classList.toggle('is-active', active);
    });
    overlay.querySelectorAll('[data-personalization-progress]').forEach((item) => {
      item.classList.toggle('is-active', Number(item.dataset.personalizationProgress) <= number);
    });
    overlay.querySelector('[data-personalization-back]').hidden = number === 1;
    overlay.querySelector('[data-personalization-next]').hidden = number === 3;
    overlay.querySelector('[data-personalization-submit]').hidden = number !== 3;
    if (number === 3) updateSummary();
    dialog.scrollTop = 0;
  };

  const validStep = () => {
    const controls = [...getStep(currentStep).querySelectorAll('input[required], select[required], textarea[required]')];
    return controls.every((control) => control.checkValidity() || (control.reportValidity(), false));
  };

  const open = (key, trigger) => {
    const offer = offers[key] || offers.book;
    if (!offer.variant) return;
    lastTrigger = trigger || document.activeElement;
    form.reset();
    form.querySelector('[data-personalization-variant]').value = offer.variant;
    form.querySelector('[data-personalization-sku]').value = offer.sku || '';
    overlay.querySelector('[data-personalization-offer]').textContent = offer.label;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('contelune-modal-open');
    syncConditionalFields();
    showStep(1);
    dialog.focus();
  };

  const close = () => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('contelune-modal-open');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  };

  const syncConditionalFields = () => {
    const customWorld = value('contelune_world') === 'CUSTOM';
    const customWorldWrap = overlay.querySelector('[data-personalization-custom]');
    const customWorldField = field('contelune_custom_world');
    customWorldWrap.hidden = !customWorld;
    customWorldField.required = customWorld;
    customWorldField.disabled = !customWorld;

    const assistedDedication = value('contelune_dedication_mode') === 'ASSISTED';
    const dedicationWrap = overlay.querySelector('[data-personalization-dedication]');
    const dedicationField = field('contelune_dedication');
    dedicationWrap.hidden = assistedDedication;
    dedicationField.disabled = assistedDedication;
    updateSummary();
  };

  document.addEventListener('contelune:open-personalization', (event) => open(event.detail?.offer, event.detail?.trigger));
  overlay.querySelectorAll('[data-personalization-close]').forEach((button) => button.addEventListener('click', close));
  overlay.querySelector('[data-personalization-next]')?.addEventListener('click', () => validStep() && showStep(currentStep + 1));
  overlay.querySelector('[data-personalization-back]')?.addEventListener('click', () => showStep(currentStep - 1));
  form.addEventListener('change', syncConditionalFields);
  form.addEventListener('input', updateSummary);
  form.addEventListener('submit', (event) => {
    updateSummary();
    if (!validStep()) event.preventDefault();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
